module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-patients-section"
  }, [_c('div', {
    staticClass: "custom-patients-section__title"
  }, [_vm._v("Patients")]), _c('div', {
    staticClass: "custom-patients-section__container"
  }, [_c('div', {
    staticClass: "custom-patients-section__container--quarter"
  }, [_c('div', {
    staticClass: "custom-patients-section__section--title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  })]), _c('div', {
    staticClass: "custom-patients-section__container--three-quarter"
  }, [_c('div', {
    staticClass: "custom-patients-section__section--body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.body)
    }
  }), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-patients-section__form-container"
  }, [_c('a', {
    staticClass: "custom-patients-section__forms",
    attrs: {
      "href": "http://formsroostergrin.com/blacker/blacker-orthodontics-patient-form-20180105.html",
      "target": "_blank"
    }
  }, [_vm._v("New Patient Form "), _c('br'), _vm._v(" (submit online)")]), _c('a', {
    staticClass: "custom-patients-section__forms",
    attrs: {
      "href": "https://extremesmiles.com/wp-content/uploads/extreme_smiles_pdf_form-1.pdf",
      "target": "_blank"
    }
  }, [_vm._v("New Patient Form "), _c('br'), _vm._v(" (print and fill)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a64f122","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-patients-section/custom-patients-section.pug
// module id = 654
// module chunks = 1